import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const clarotyXdome = defineConnector({
  identifier: "clarotyXdome",
  name: "Claroty xDome",
  tagLine: "Industrial cybersecurity",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.claroty\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log into your [Claroty xDome](https://claroty.com/industrial-cybersecurity/xdome) console and navigate to **Administration** > **API Keys** to generate an API token.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "hostname",
          label: "Instance URL",
          placeholder: "your-instance.claroty.com",
          required: true,
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "Your Claroty xDome instance URL.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `https://${instanceUrl}/api/v1/health`,
  },
  publicEnvVars: ({ instanceUrl }) => ({
    CLAROTY_XDOME_URL: instanceUrl ? `https://${instanceUrl}` : "",
  }),
});
